import React, { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MarkModal from './MarkModal';
import { UnsavedChangesContext } from './UnsavedChangesProvider';

const MarkFormModal: React.FC<{ title: string; returnTo: string; children: React.ReactNode }> = ({
    title,
    returnTo,
    children
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { anySaving } = useContext(UnsavedChangesContext);
    return (
        <MarkModal
            aria-label={title}
            onClose={() => {
                const search = new URLSearchParams(location.search);
                ['resume', 'segment_id'].forEach((key) => search.delete(key));
                navigate({ pathname: returnTo, search: search.toString() });
            }}
            isPending={anySaving}
        >
            {children}
        </MarkModal>
    );
};

export default MarkFormModal;
